/**
 * Contract Notices Service
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.6.13
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface UpdateSaleRequest { 
    trusteesIds?: Array<string>;
    debtorsIds?: Array<string>;
    locations?: Array<string>;
    placesOfSale?: Array<string>;
    publicationUrl?: string;
    fileUrl?: string;
    type?: UpdateSaleRequest.TypeEnum;
    publicationDate?: Date;
    saleDate?: Date;
    text?: string;
    eSale?: boolean;
}
export namespace UpdateSaleRequest {
    export type TypeEnum = 'REAL_ESTATE' | 'MOVABLE_PROPERTY' | 'REAL_MOVABLE' | 'BUILDABLE_LAND' | 'LEASE_RENTAL' | 'AMENDMENT' | 'CANCELLATION';
    export const TypeEnum = {
        REALESTATE: 'REAL_ESTATE' as TypeEnum,
        MOVABLEPROPERTY: 'MOVABLE_PROPERTY' as TypeEnum,
        REALMOVABLE: 'REAL_MOVABLE' as TypeEnum,
        BUILDABLELAND: 'BUILDABLE_LAND' as TypeEnum,
        LEASERENTAL: 'LEASE_RENTAL' as TypeEnum,
        AMENDMENT: 'AMENDMENT' as TypeEnum,
        CANCELLATION: 'CANCELLATION' as TypeEnum
    };
}